<template>
    <section class="picture">
        <slot/>
    </section>
</template>
<script>
export default {
    name: 'SectionPicture',
};
</script>
<style lang="scss" scoped>
section.picture {
    justify-self: center;

    > svg {
        width: 200px;
        max-width: 100%;
    }
}
</style>
